import React from "react";

import { getSettings } from "@services/configService";

interface MetaData {
    title?: string;
    description?: string;
    withoutTitleSuffix?: boolean;
}

export const withMetaDescription = (WrappedComponent: React.ComponentType, metaData: MetaData) => {
    const ComponentWithMeta: React.FC = (props) => {
        // Reads settings at render time — withMetaDescription is applied at module load via
        // `export default withMetaDescription(Page, ...)`, which fires before ConfigLoader has
        // resolved. Doing the read here defers it until ConfigLoader gates the tree below.
        const { features } = getSettings();

        const getTitle = () => {
            if (!metaData.title || metaData.withoutTitleSuffix) {
                return features.title;
            }

            return metaData.title + " - " + features.title;
        };

        return (
            <React.Fragment>
                <title>{getTitle()}</title>
                {metaData.description ? <meta name="description" content={metaData.description} /> : null}
                <link id="favicon" rel="icon" href={features.favicon} />
                <WrappedComponent {...props} />
            </React.Fragment>
        );
    };

    return ComponentWithMeta;
};
